import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/index';

const features = [
  { title: 'SIMRS Terintegrasi', desc: 'Sistem Informasi Manajemen Rumah Sakit lengkap dari pendaftaran hingga farmasi.', icon: '🏥' },
  { title: 'Rekam Medis Elektronik', desc: 'EMR digital yang aman dengan akses cepat ke riwayat pasien dan hasil lab.', icon: '📋' },
  { title: 'HRIS & Payroll', desc: 'Kelola data karyawan, absensi, cuti, dan penggajian dalam satu sistem.', icon: '👥' },
  { title: 'Manajemen Apotek', desc: 'Kontrol stok obat, resep elektronik, dan pelaporan BPOM otomatis.', icon: '💊' },
  { title: 'Integrasi BPJS', desc: 'Bridging langsung ke sistem BPJS Kesehatan untuk klaim dan verifikasi.', icon: '🔗' },
  { title: 'Pelaporan & Analitik', desc: 'Dashboard dan laporan yang memenuhi standar Kemenkes RI.', icon: '📊' },
];

const SimrsHrisPage = () => {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <section className="relative bg-gradient-to-br from-emerald-900 via-green-800 to-teal-900 text-white py-24 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">SIMRS & HRIS</h1>
          <p className="text-lg md:text-xl text-emerald-200 max-w-3xl mx-auto">
            Sistem informasi rumah sakit dan manajemen SDM yang terintegrasi, aman, dan sesuai regulasi Indonesia.
          </p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-white">Modul Tersedia</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div key={f.title} className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="text-4xl mb-4">{f.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-gray-800 dark:text-white">{f.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-emerald-900 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Digitalisasi Fasilitas Kesehatan Anda</h2>
          <p className="text-emerald-200 mb-8">Konsultasikan kebutuhan SIMRS dan HRIS Anda dengan tim ahli kami.</p>
          <Link to="/kontak" className="inline-block bg-white text-emerald-900 font-bold px-8 py-4 rounded-xl hover:bg-emerald-50 transition-colors">
            Hubungi Kami
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SimrsHrisPage;
